<template>
  <div id="onlineOrderingStyle">
    <div class="container" v-if="branch">

      <div class="openWebApp">
        <a class="btn btn-primary" v-if="branch" :href="'https://web.ishopfood.com/#/' + branch.nameCanonical"
          target="_blank">
          Ouvrir le site dans un nouvel onglet
          <svgicon src="/icon/arrow.svg" height="9" width="12"></svgicon>
        </a>
        <div class="grow"></div>
        <div class="btn btn-secondary" style="margin-right: 10px;" @click="exportConfig">Exporter</div>
        <input id="importFile" type="file" style="display:none;" accept="application/json" @change="importConfig($event)">
        <label for="importFile" class="btn btn-secondary" style="margin-right: 10px;">Importer...</label>
        <div class="btn btn-secondary" @click="reset">Réinitialiser le visuel</div>
      </div>

      <Tabs>

        <TabSection ref="generalPanel" title="Général">
          <Panel title="Configuration des couleurs" collapsible>
            <p class="description">
              Création des couleurs disponibles pour la configuration du visuel.
              <button class="btn btn-primary add" @click="addColor">
                <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
              </button>
            </p>
            <div class="color" v-for="(color, colorIndex) of colors" :key="colorIndex">
              <div class="group">
                <label>Nom</label>
                <input type="text" v-model="color.name" placeholder="Nom de la couleur">
              </div>
              <div class="group">
                <label>Couleur</label>
                <input type="color" v-model="color.value">
              </div>
              <a class="delete" href="javascript:void(0)" @click="colors.splice(colorIndex, 1)">
                <svgicon src="/icon/close.svg" height="15" width="15"></svgicon>
              </a>
            </div>
          </Panel>

          <Panel title="Style avancé" collapsible>
            <p class="description">Vous pouvez ajouter ici du style CSS personnalisé qui sera ajouté à votre application.
            </p>
            <div class="group">
              <label>CSS</label>
              <textarea class="customCss" placeholder="" v-model="customCss"></textarea>
            </div>
          </Panel>

          <Panel title="Configuration avancée" collapsible>
            <div class="columns">
              <div class="column">
                <div class="group">
                  <label>Style d'affichage général</label>
                  <select v-model="styleMode" width="50%">
                    <option :value="mode" v-for="mode of styleModes">{{ $t("style_mode." + mode) }}</option>
                  </select>
                </div>
                <div class="group">
                  <label>Style d'affichage des photos de produits et catégories</label>
                  <select v-model="itemImageBackgroundSize" width="50%">
                    <option value="contain">Contenir toute l'image dans la surface</option>
                    <option value="cover">Remplir la surface avec l'image</option>
                  </select>
                </div>
                <div class="group" v-if="styleMode == 'quick'">
                  <input type="checkbox" id="chk_quickAdd" v-model="quickAdd">
                  <label for="chk_quickAdd">Activer l'ajout rapide de produits (dans un pop-up)</label>
                </div>
                <div class="group" v-if="styleMode == 'quick'">
                  <input type="checkbox" id="chk_forceQuickAdd" v-model="forceQuickAdd">
                  <label for="chk_forceQuickAdd">Forcer l'ajout de produits dans un pop-up pour tous les produits</label>
                </div>
                <div class="group" v-if="styleMode == 'quick'">
                  <input type="checkbox" id="chk_displayAboutOnlineOrdering" v-model="displayAboutOnlineOrdering">
                  <label for="chk_displayAboutOnlineOrdering">Afficher la section 'à propos' dans le pop-up de
                    configuration de commande</label>
                </div>
                <div class="group" v-if="styleMode === 'quick'">
                  <input type="checkbox" id="chk_displayQuickCategories" v-model="displayQuickCategories">
                  <label for="chk_displayQuickCategories">Permettre la navigation des catégories avec images</label>
                </div>
                <div class="group">
                  <input id="chkCategoriesDescription" type="checkbox" v-model="showCategoriesDescription">
                  <label for="chkCategoriesDescription">Afficher la description des catégories</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_hideCategoryTitles" v-model="hideCategoryTitles">
                  <label for="chk_hideCategoryTitles">Cacher les titres des catégories</label>
                </div>
                <div class="group">
                  <input id="chkDiscreteProductPrice" type="checkbox" v-model="discreteProductPrice">
                  <label for="chkDiscreteProductPrice">Afficher discrètement les prix des produits dans le menu</label>
                </div>
                <div class="group">
                  <input id="chkVariantAsUpsell" type="checkbox" v-model="variantPriceAsUpsell">
                  <label for="chkVariantAsUpsell">Afficher le prix des variantes en tant que supplément</label>
                </div>
                <div class="group">
                  <input id="chkCompanyLogoOverride" type="checkbox" v-model="companyLogoOverride">
                  <label for="chkCompanyLogoOverride">Remplacer le logo de base de l'organisation par celui de la
                    succursale</label>
                </div>
                <div class="group">
                  <input id="chkCompanyHorLogoOverride" type="checkbox" v-model="companyHorizontalLogoOverride">
                  <label for="chkCompanyHorLogoOverride">Remplacer le logo horizontal de l'organisation par celui de la
                    succursale</label>
                </div>
              </div>
              <div class="column advancedConfigPadding">
                <label class="section-title">Configuration de l'ajout d'un produit au panier</label>
                <div class="group">
                  <input type="radio" id="chk_interactiveMode" :value="true" v-model="interactiveMode">
                  <label for="chk_interactiveMode">Mode interactif : animations, défilement automatique et aucune
                    présélection de choix</label>
                  <input type="radio" id="chk_staticMode" :value="false" v-model="interactiveMode">
                  <label for="chk_staticMode">Mode statique : animations minimales et présélection de choix</label>
                </div>
                <div class="group" v-if="interactiveMode">
                  <input id="chk_forceModifierInteraction" type="checkbox" v-model="forceModifierInteraction">
                  <label for="chk_forceModifierInteraction">Forcer l'interaction avec les extras et remarques et cacher le
                    bouton 'suivant'</label>
                </div>
                <label class="section-title">Configuration de l'affichage des produits dans le panier</label>
                <div class="group">
                  <input type="radio" id="chk_cartItemsClassic" value="classic" v-model="cartItemsMode">
                  <label for="chk_cartItemsClassic">Mode classique : les produits s'affichent en blocs dans le panier,
                    avec séparation et images</label>
                  <input type="radio" id="chk_cartItemsCompact" value="compact" v-model="cartItemsMode">
                  <label for="chk_cartItemsCompact">Mode compact : les produits s'affichent en liste dans le panier, sans
                    séparation ou image</label>
                </div>
                <label class="section-title">Configuration de l'affichage des extras et modifications au produit</label>
                <div class="group">
                  <input type="radio" id="chk_modifierList" value="list" v-model="modifiersMode">
                  <label for="chk_modifierList">Mode liste : affichage des extras, remarques et variantes sous forme de
                    liste</label>
                  <input type="radio" id="chk_modifierButton" value="button" v-model="modifiersMode">
                  <label for="chk_modifierButton">Mode bouton : affichage des extras, remarques et variantes sous forme de
                    boutons</label>
                </div>
              </div>
            </div>

            <div class="br"></div>

            <div class="columns">
              <div class="column">
                <label class="section-title">Affichage sur mobile</label>
                <div class="group">
                  <label>Nombre de produits à afficher par ligne</label>
                  <select v-model="mobileProductsPerRow">
                    <option :value="1">1</option>
                    <option :value="2">2</option>
                  </select>
                </div>
                <div class="group" v-if="branch.homePage && branch.homePage.activated">
                  <label>Alignement de l'en-tête de la page d'accueil dans l'application mobile</label>
                  <select v-model="homePageAlignment">
                    <option value="left">Aligné à gauche</option>
                    <option value="center">Aligné au centre</option>
                    <option value="right">Aligné à droite</option>
                  </select>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_productListModeM" v-model="listMode.item.mobile">
                  <label for="chk_productListModeM">Afficher les produits du menu sous format liste</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_categoryListModeM" v-model="listMode.category.mobile">
                  <label for="chk_categoryListModeM">Afficher les catégories du menu sous format liste</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_showMobileFooter" v-model="showMobileFooter">
                  <label for="chk_showMobileFooter">Afficher le navigation du bas (footer) dans l'application
                    mobile</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_horizontalLogoInMobileHeader" v-model="horizontalLogoInMobileHeader">
                  <label for="chk_horizontalLogoInMobileHeader">Afficher le logo horizontal dans l'en-tête l'application
                    mobile</label>
                </div>
                <div class="group" v-if="styleMode === 'classic'">
                  <input type="checkbox" id="chk_replaceCompaniesByOrderType"
                    v-model="replaceCompaniesLinkByOrderTypeLink">
                  <label for="chk_replaceCompaniesByOrderType">Remplacer le lien 'Nos succursales' par un lien vers les
                    options de commande dans le menu mobile</label>
                </div>
              </div>
              <div class="column">
                <label class="section-title">Affichage sur ordinateur</label>
                <div class="group">
                  <input type="checkbox" id="chk_productListMode" v-model="listMode.item.desktop">
                  <label for="chk_productListMode">Afficher les produits du menu sous format liste</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_categoryListMode" v-model="listMode.category.desktop">
                  <label for="chk_categoryListMode">Afficher les catégories du menu sous format liste</label>
                </div>
              </div>
            </div>
          </Panel>

          <Panel title="Configuration du programme de fidélité iShopFood" collapsible collapsed
            v-if="branch.loyaltyActivated && branch.loyaltyConfig && branch.loyaltyConfig.type === 'ishopfood'">
            <div class="columns">
              <div class="column">
                <label class="section-title">Format d'affichage de la fidélité</label>
                <div class="group">
                  <input type="radio" id="chk_fidelityFormatCard" value="card" v-model="fidelity.format">
                  <label for="chk_fidelityFormatCard">Carte de points</label>
                  <input type="radio" id="chk_fidelityFormatProgress" value="progress" v-model="fidelity.format">
                  <label for="chk_fidelityFormatProgress">Progression</label>
                </div>
              </div>
              <div class="column">
                <div class="group" v-if="fidelity.format === 'progress'">
                  <input type="checkbox" id="chk_progressBarFooter" v-model="fidelity.displayFooterProgressBar">
                  <label for="chk_progressBarFooter">Afficher la barre de progression en mobile</label>
                </div>
              </div>
            </div>
          </Panel>

          <Panel title="Configuration du tutoriel" collapsible collapsed
            v-if="branch.tutorial && branch.tutorial.activated">
            <div class="columns">
              <div class="column">
                <div class="group">
                  <input type="checkbox" id="chk_displayCoverBackgroundImages"
                    v-model="tutorial.displayCoverBackgroundImage">
                  <label for="chk_displayCoverBackgroundImages">Afficher une image de fond</label>
                </div>
                <div class="group">
                  <input type="checkbox" id="chk_fullWidthImages" v-model="tutorial.fullWidthImages">
                  <label for="chk_fullWidthImages">Afficher les images du tutoriel en pleine largeur</label>
                </div>
              </div>
              <div class="column">
              </div>
            </div>
          </Panel>
        </TabSection>

        <TabSection ref="mediaPanel" title="Gestion des médias (images et vidéos)" v-if="branch">

          <Panel title="Image de fond" collapsible collapsed>
            <ImageUpload identifier="uploadImageBackground" :object="branch.backgroundImage" :maxSizeInMb="1"
              @changed="branch.backgroundImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Logo horizontal" collapsible collapsed>
            <ImageUpload identifier="uploadImageHorizontalLogo" :object="branch.horizontalLogo" :maxSizeInMb="0.8"
              @changed="branch.horizontalLogo = $event"></ImageUpload>
          </Panel>

          <Panel title="Logo de navigation" collapsible collapsed>
            <ImageUpload identifier="uploadImageNavigationLogo" :object="branch.navigationLogo" :maxSizeInMb="0.8"
              @changed="branch.navigationLogo = $event"></ImageUpload>
          </Panel>

          <Panel title="Fond du logo de navigation" collapsible collapsed>
            <ImageUpload identifier="uploadImageNavigationLogoBackground" :object="branch.navigationLogoBackground"
              :maxSizeInMb="0.8" @changed="branch.navigationLogoBackground = $event"></ImageUpload>
          </Panel>

          <Panel title="Logo de la navigation mobile" collapsible collapsed>
            <ImageUpload identifier="uploadImageMobileMenuLogo" :object="branch.mobileMenuLogo" :maxSizeInMb="0.8"
              @changed="branch.mobileMenuLogo = $event"></ImageUpload>
          </Panel>

          <Panel title="Image de produit par défaut" collapsible collapsed>
            <ImageUpload identifier="uploadDefaultItemImage" :object="branch.defaultItemImage" :maxSizeInMb="0.8"
              @changed="branch.defaultItemImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Méthodes de commande" collapsible collapsed>

            <Panel title="Pour emporter" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <label><b>Image de fond</b></label>
                  <ImageUpload identifier="uploadTakeoutBackgroundImage" :object="branch.takeoutBackgroundImage"
                    :maxSizeInMb="1" @changed="branch.takeoutBackgroundImage = $event"></ImageUpload>
                </div>
                <div class="column">
                  <label><b>Image en transparence sur le fond</b></label>
                  <ImageUpload identifier="uploadTakeoutImage" :object="branch.takeoutImage" :maxSizeInMb="1"
                    @changed="branch.takeoutImage = $event"></ImageUpload>
                </div>
              </div>
            </Panel>

            <Panel title="Livraison" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <label><b>Image de fond</b></label>
                  <ImageUpload identifier="uploadDeliveryBackgroundImage" :object="branch.deliveryBackgroundImage"
                    :maxSizeInMb="0.8" @changed="branch.deliveryBackgroundImage = $event"></ImageUpload>
                </div>
                <div class="column">
                  <label><b>Image en transparence sur le fond</b></label>
                  <ImageUpload identifier="uploadDeliveryImage" :object="branch.deliveryImage" :maxSizeInMb="0.8"
                    @changed="branch.deliveryImage = $event"></ImageUpload>
                </div>
              </div>
            </Panel>

            <Panel title="En salle" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <label><b>Image de fond</b></label>
                  <ImageUpload identifier="uploadInPlaceBackgroundImage" :object="branch.inPlaceBackgroundImage"
                    :maxSizeInMb="0.8" @changed="branch.inPlaceBackgroundImage = $event"></ImageUpload>
                </div>
                <div class="column">
                  <label><b>Image en transparence sur le fond</b></label>
                  <ImageUpload identifier="uploadInPlaceImage" :object="branch.inPlaceImage" :maxSizeInMb="0.8"
                    @changed="branch.inPlaceImage = $event"></ImageUpload>
                </div>
              </div>
            </Panel>

            <Panel title="Traiteur" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <label><b>Image de fond</b></label>
                  <ImageUpload identifier="uploadCateringBackgroundImage" :object="branch.cateringBackgroundImage"
                    :maxSizeInMb="0.8" @changed="branch.cateringBackgroundImage = $event"></ImageUpload>
                </div>
                <div class="column">
                  <label><b>Image en transparence sur le fond</b></label>
                  <ImageUpload identifier="uploadCateringImage" :object="branch.cateringImage" :maxSizeInMb="0.8"
                    @changed="branch.cateringImage = $event"></ImageUpload>
                </div>
              </div>
            </Panel>

            <Panel title="Service de chambre" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <label><b>Image de fond</b></label>
                  <ImageUpload identifier="uploadHotelBackgroundImage" :object="branch.hotelBackgroundImage"
                    :maxSizeInMb="0.8" @changed="branch.hotelBackgroundImage = $event"></ImageUpload>
                </div>
                <div class="column">
                  <label><b>Image en transparence sur le fond</b></label>
                  <ImageUpload identifier="uploadHotelImage" :object="branch.hotelImage" :maxSizeInMb="0.8"
                    @changed="branch.hotelImage = $event"></ImageUpload>
                </div>
              </div>
            </Panel>

          </Panel>

          <Panel title="Choix de la méthode de commande (mobile de la commande classique)" collapsible collapsed>
            <ImageUpload identifier="uploadMobileOrderTypeImage" :object="branch.mobileOrderTypeImage" :maxSizeInMb="0.8"
              @changed="branch.mobileOrderTypeImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Fenêtre de configuration de commande (pour commande rapide)" collapsible collapsed>
            <ImageUpload identifier="uploadModalOrderTypeImage" :object="branch.modalOrderTypeImage" :maxSizeInMb="0.8"
              @changed="branch.modalOrderTypeImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Image de fond d'accueil" collapsible collapsed>
            <ImageUpload identifier="uploadHubImage" :object="branch.hubImage" :maxSizeInMb="0.8"
              @changed="branch.hubImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Marqueur de carte" collapsible collapsed>
            <ImageUpload identifier="uploadMapMarkerImage" :object="branch.mapMarkerImage" :maxSizeInMb="0.8"
              @changed="branch.mapMarkerImage = $event"></ImageUpload>
          </Panel>

          <Panel title="Tutoriel" collapsible collapsed v-if="branch.tutorial && branch.tutorial.activated">
            <div class="columns">
              <div class="column">
                <label><b>Image de fond du tutoriel</b></label>
                <ImageUpload identifier="uploadTutorialBackgroundImage" :object="branch.tutorial.backgroundImage"
                  :maxSizeInMb="0.8" @changed="branch.tutorial.backgroundImage = $event"></ImageUpload>
              </div>
              <div class="column">
                <label><b>Logo du tutoriel</b></label>
                <ImageUpload identifier="uploadTutorialLogoImage" :object="branch.tutorial.logoImage" :maxSizeInMb="0.8"
                  @changed="branch.tutorial.logoImage = $event"></ImageUpload>
              </div>
            </div>
          </Panel>

          <Panel title="Page d'accueil (application mobile)" collapsible collapsed
            v-if="branch.homePage && branch.homePage.activated">
            <div class="columns">
              <div class="column">
                <label><b>Image de fond de la page d'accueil</b></label>
                <ImageUpload identifier="uploadHomePageBackgroundImage" :object="branch.homePage.backgroundImage"
                  :maxSizeInMb="1" @changed="branch.homePage.backgroundImage = $event"></ImageUpload>
              </div>
              <div class="column" v-show="false">
                <label><b>Vidéo de fond de la page d'accueil (la vidéo à priorité sur l'image)</b></label>
                <ImageUpload identifier="uploadHomePageVideo" video :object="branch.homePage.backgroundVideo"
                  @changed="branch.homePage.backgroundVideo = $event"></ImageUpload>
              </div>
            </div>
          </Panel>

          <Panel title="Spinner (Image lors d'un chargement)" collapsible collapsed>
            <div class="columns">
              <div class="column">
                <label><b>Spinner animé (primaire)</b></label>
                <ImageUpload identifier="uploadSpinnerAnimatedImage" :object="branch.spinnerAnimatedImage"
                  :maxSizeInMb="0.8" @changed="branch.spinnerAnimatedImage = $event"></ImageUpload>
              </div>
              <div class="column">
                <label><b>Spinner statique (facultatif)</b></label>
                <ImageUpload identifier="uploadSpinnerStaticImage" :object="branch.spinnerStaticImage" :maxSizeInMb="0.8"
                  @changed="branch.spinnerStaticImage = $event"></ImageUpload>
              </div>
            </div>
          </Panel>

          <Panel title="Paiement QR" collapsible collapsed v-if="isQrPaymentActive">
            <div class="columns">
              <div class="column">
                <label><b>Logo (page d'accueil)</b></label>
                <ImageUpload identifier="uploadPayAtTheTableLogo" :object="branch.payAtTheTable.logo" :maxSizeInMb="0.8"
                  @changed="branch.payAtTheTable.logo = $event"></ImageUpload>
              </div>
              <div class="column">
                <label><b>Image de fond (page d'accueil)</b></label>
                <ImageUpload identifier="uploadPayAtTheTableBackgroundImage"
                  :object="branch.payAtTheTable.backgroundImage" :maxSizeInMb="1"
                  @changed="branch.payAtTheTable.backgroundImage = $event"></ImageUpload>
              </div>
            </div>
          </Panel>

          <Panel title="Image de promotion par défaut" collapsible collapsed>
            <ImageUpload identifier="uploadDefaultPromotionImage"
                        :object="branch.defaultPromotionImage" :maxSizeInMb="0.8"
                        @changed="branch.defaultPromotionImage = $event"></ImageUpload>
          </Panel>

        </TabSection>

        <template v-for="(style, styleIndex) of stylesToConfigure" v-if="selectors">
          <TabTitle>{{ $t('style.styles.' + style) }}</TabTitle>
          <template v-for="(section, sectionIndex) of configurableStyle[style]" v-if="selectors">
            <TabSection :ref="'stylePanel' + styleIndex + '' + sectionIndex" :title="$t(section.description)">

              <div class="group" v-for="(selector, selectorIndex) of section.selectors"
                :key="sectionIndex + '-' + selectorIndex">

                <label>{{ $t(selector.description) }}</label>

                <div class="selector" v-if="hasAttribute(selector, 'color')">
                  <Tooltip text="Choix d'une couleur de texte"></Tooltip>
                  <ColorSelector :colors="colors" :value="getSelector(selector.selector, 'color').value"
                    v-if="getSelector(selector.selector, 'color')"
                    @changed="getSelector(selector.selector, 'color').value = $event"
                    placeholder="Choisir une couleur de texte"></ColorSelector>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'fill')">
                  <Tooltip text="Choix d'une couleur d'icône"></Tooltip>
                  <ColorSelector :colors="colors" :value="getSelector(selector.selector, 'fill').value"
                    v-if="getSelector(selector.selector, 'fill')"
                    @changed="getSelector(selector.selector, 'fill').value = $event"
                    placeholder="Choisir une couleur d'icône"></ColorSelector>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'border-radius')">
                  <Tooltip text="Choix d'une rondeur de bordure (en radius px)"></Tooltip>
                  <input type="number" min="0" step="1" class="number-select"
                    v-if="getSelector(selector.selector, 'border-radius')"
                    v-model="getSelector(selector.selector, 'border-radius').value"
                    placeholder="Rondeur des bordures (radius px)">
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'background-color')">
                  <Tooltip text="Choix d'une couleur de fond"></Tooltip>
                  <ColorSelector :colors="colors" :value="getSelector(selector.selector, 'background-color').value"
                    v-if="getSelector(selector.selector, 'background-color')"
                    @changed="getSelector(selector.selector, 'background-color').value = $event"
                    placeholder="Choisir une couleur de fond"></ColorSelector>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'background-image')">
                  <!-- TODO -->
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'opacity')">
                  <Tooltip text="Choix d'une valeur de transparence (entre 0 et 1)"></Tooltip>
                  <input type="number" min="0" max="1" step="0.01" class="number-select"
                    v-if="getSelector(selector.selector, 'opacity')"
                    v-model="getSelector(selector.selector, 'opacity').value" placeholder="Transparence">
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'font-family')">
                  <Tooltip text="Choix d'une police d'écriture"></Tooltip>
                  <select class="font-select" v-if="getSelector(selector.selector, 'font-family')"
                    :style="{ fontFamily: getSelector(selector.selector, 'font-family').value }"
                    v-model="getSelector(selector.selector, 'font-family').value">
                    <option value="" selected hidden>Choisir une police d'écriture...</option>
                    <option v-for="font of fonts" :value="font" :style="{ fontFamily: font }" :key="font">{{ font }}
                    </option>
                  </select>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'font-size')">
                  <Tooltip text="Taille de la police (en px)"></Tooltip>
                  <input type="number" min="0" step="1" class="number-select"
                    v-if="getSelector(selector.selector, 'font-size')"
                    v-model="getSelector(selector.selector, 'font-size').value" placeholder="Taille de police">
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'font-weight')">
                  <Tooltip text="Choix d'une épaisseur de police"></Tooltip>
                  <select class="font-select" v-if="getSelector(selector.selector, 'font-weight')"
                    :style="{ fontWeight: getSelector(selector.selector, 'font-weight').value, fontFamily: 'Roboto' }"
                    v-model="getSelector(selector.selector, 'font-weight').value">
                    <option value="" selected hidden>Choisir une épaisseur d'écriture...</option>
                    <option v-for="weight of weights" :value="weight" :style="{ fontWeight: weight }" :key="weight">
                      {{ weightText(weight) }}</option>
                  </select>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'display')">
                  <Tooltip text="Choix de méthode d'affichage"></Tooltip>
                  <select class="font-select" v-if="getSelector(selector.selector, 'display')"
                    v-model="getSelector(selector.selector, 'display').value">
                    <option value="" selected hidden>Choisir une méthode d'affichage...</option>
                    <option v-for="mode of display" :value="mode.value" :key="mode.name">{{ mode.name }}</option>
                  </select>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'border-color')">
                  <Tooltip text="Choix d'une couleur de bordure"></Tooltip>
                  <ColorSelector :colors="colors" :value="getSelector(selector.selector, 'border-color').value"
                    v-if="getSelector(selector.selector, 'border-color')"
                    @changed="getSelector(selector.selector, 'border-color').value = $event"
                    placeholder="Choisir une couleur de bordure"></ColorSelector>
                </div>

                <div class="selector" v-if="hasRegexAttribute(selector, /^border(-(left|right|top|bottom))?$/)">
                  <Tooltip text="Choix une taille, une couleur et un style de bordure"></Tooltip>
                  <BorderSelector :colors="colors"
                    :value="getSelector(selector.selector, hasRegexAttribute(selector, /^border(-(left|right|top|bottom))?$/)).value"
                    v-if="getSelector(selector.selector, hasRegexAttribute(selector, /^border(-(left|right|top|bottom))?$/))"
                    @changed="getSelector(selector.selector, hasRegexAttribute(selector, /^border(-(left|right|top|bottom))?$/)).value = $event">
                  </BorderSelector>
                </div>

                <div class="selector" v-if="hasAttribute(selector, 'placeholder')">
                  <Tooltip text="Choix d'une couleur de texte de remplacement"></Tooltip>
                  <ColorSelector :colors="colors" :value="getSelector(selector.selector, 'placeholder').value"
                    v-if="getSelector(selector.selector, 'placeholder')"
                    @changed="getSelector(selector.selector, 'placeholder').value = $event"
                    placeholder="Choisir une couleur de texte de remplacement"></ColorSelector>
                </div>

                <div class="selector background" v-if="hasAttribute(selector, 'background')">
                  <Tooltip
                    text="Choix d'un fond personnalisé: <br>linear-gradient(couleur1, couleur2)<br>rgba(255,255,255,255)<br>etc.">
                  </Tooltip>
                  <input type="text" class="background-select" v-if="getSelector(selector.selector, 'background')"
                    v-model="getSelector(selector.selector, 'background').value"
                    placeholder="Fond personnalisé: linear-gradient(couleur1, couleur2), rgba(255,255,255,255), #000000, etc. ">
                  <div class="preview" :style="{ background: getSelector(selector.selector, 'background').value }"></div>
                </div>

              </div>
            </TabSection>
          </template>
        </template>

      </Tabs>
      <button class="btn btn-save btn-primary" @click="save">{{ $t('save') }}</button>

    </div>
  </div>
</template>

<script>
  import ImageUpload from '@/components/tools/ImageUpload.vue';
  import ColorSelector from "@/components/style/ColorSelector.vue";
  import BorderSelector from "@/components/style/BorderSelector.vue";
  import Tooltip from "@/components/tools/Tooltip";
  import { mapActions } from "vuex";
  import ConfigurableStyle from "@/resources/configurableStyle.json";
  import TabTitle from "@/components/navigation/TabTitle";

  export default {
    name: "onlineOrderingStyle",

    components: { ColorSelector, Tooltip, ImageUpload, BorderSelector, TabTitle },

    data() {
      return {
        company: null,
        isBranchCompany: true,
        isDemo: false,
        branchId: null,
        version: "0.0.1",
        customCss: "",
        itemListMode: false,
        quickAdd: false,
        interactiveMode: false,
        categoryListMode: false,
        forceQuickAdd: false,
        showCategoriesDescription: false,
        variantPriceAsUpsell: false,
        horizontalLogoInMobileHeader: false,
        displayAboutOnlineOrdering: false,
        displayQuickCategories: false,
        hideCategoryTitles: false,
        showMobileFooter: false,
        forceModifierInteraction: false,
        discreteProductPrice: false,
        replaceCompaniesLinkByOrderTypeLink: false,
        itemImageBackgroundSize: "cover",
        homePageAlignment: "center",
        styleMode: "classic",
        cartItemsMode: "classic",
        mobileProductsPerRow: 1,
        companyLogoOverride: false,
        companyHorizontalLogoOverride: false,
        modifiersMode: "list",
        fidelity: {
          format: 'card',
          displayFooterProgressBar: false
        },
        tutorial: {
          displayCoverBackgroundImage: false,
          fullWidthImages: false
        },
        listMode: {
          item: {
            mobile: false,
            desktop: false
          },
          category: {
            mobile: false,
            desktop: false
          }
        },
        qrPaymentStyle: "qr_payment",
        configurableStyle: ConfigurableStyle,
        colors: [],
        styleModes: ["classic", "quick"],
        selectors: [],
        fonts: ["Roboto", "Segoe UI", "Segoe UI Black", "Oswald", "Cinzel", "Acme", "Abel",
          "Aldrich", "Blogger Sans", "Cinzel Decorative", "Lato", "Yanone Kaffeesatz",
          "Arial", "Times New Roman", "Helvetica", "Courier New", "Dharma Gothic",
          "Verdana", "Georgia", "Palatino", "Garamond", "Vanguard CF", "GT America Condensed",
          "Trebuchet MS", "Arial Black", "Impact", "Nanami", "Quicksand", "Happiness",
          "Chivo", "Distro", "HVD", "Gagalin", "Raleway", "Raleway Black", "Josefin Slab", "Josefin Sans", "Barlow"].sort(),
        weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
        display: [{ name: "Block", value: "block" }, { name: "Hidden", value: "none" }],
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "style.onlineOrdering";
      this.$store.state.pageIcon = "icon/art.svg";

      this.branchId = this.$route.query.branch;

      if (this.branch) {
        this.getBranchStyle();
        this.buildSelectors();
      }
    },

    computed: {
      branch() {
        return this.$store.state.contextBranch;
      },
      weightText() {
        let weightArray = ["Thin", "Extra-Light", "Light", "Normal", "Medium", "Semi-Bold", "Bold", "Extra-Bold", "Black"]
        return weight => {
          return weightArray[Math.floor(weight / 100) - 1];
        };
      },
      isQrPaymentActive() {
        return this.branch.payAtTheTable && this.branch.payAtTheTable.activated
      },
      stylesToConfigure() {
        let styles = ['basic'];

        if (this.isQrPaymentActive) {
          styles.push('qr_payment');
        }
        return styles;
      }
    },

    watch: {
      "branch": function (to, from) {
        if (to && !from) {
          this.getBranchStyle();
          this.buildSelectors();
        }
      }
    },

    methods: {
      ...mapActions(["saveBranch"]),

      getBranchStyle() {
        let css = this.branch.cssData;
        if (css) {
          this.colors = css.colors || [];
          this.customCss = css.customCss || "";
          this.listMode = css.listMode || {
            item: {
              mobile: false,
              desktop: false
            },
            category: {
              mobile: false,
              desktop: false
            }
          };
          this.fidelity = css.fidelity || {
            format: 'card',
            displayFooterProgressBar: false
          };
          this.tutorial = css.tutorial || {
            displayCoverBackgroundImage: false,
            fullWidthImages: false
          };
          this.replaceCompaniesLinkByOrderTypeLink = css.replaceCompaniesLinkByOrderTypeLink || false;
          this.homePageAlignment = css.homePageAlignment || "center";
          this.mobileProductsPerRow = css.mobileProductsPerRow || 1;
          this.styleMode = css.styleMode || "classic";
          this.itemImageBackgroundSize = css.itemImageBackgroundSize || "cover";
          this.categoryListMode = css.categoryListMode || false;
          this.hideCategoryTitles = css.hideCategoryTitles || false;
          this.displayAboutOnlineOrdering = css.displayAboutOnlineOrdering || false;
          this.displayQuickCategories = css.displayQuickCategories || false;
          this.quickAdd = css.quickAdd || false;
          this.forceQuickAdd = css.forceQuickAdd || false;
          this.horizontalLogoInMobileHeader = css.horizontalLogoInMobileHeader || false;
          this.showMobileFooter = css.showMobileFooter || false;
          this.interactiveMode = css.interactiveMode || false;
          this.companyLogoOverride = css.companyLogoOverride || false;
          this.companyHorizontalLogoOverride = css.companyHorizontalLogoOverride || false;
          this.discreteProductPrice = css.discreteProductPrice || false;
          this.variantPriceAsUpsell = css.variantPriceAsUpsell || false;
          this.forceModifierInteraction = css.forceModifierInteraction || false;
          this.version = css.version || "0.0.1";
          this.selectors = css.selectors || [];
          this.showCategoriesDescription = css.showCategoriesDescription;
          this.modifiersMode = css.modifiersMode || "list";
          this.cartItemsMode = css.cartItemsMode || "classic";
        }
      },

      reset() {
        this.version = "0.0.1";
        this.selectors = [];
        this.showCategoriesDescription = false;
        this.interactiveMode = false;
        this.showMobileFooter = false;
        this.categoryListMode = false;
        this.hideCategoryTitles = false;
        this.discreteProductPrice = false;
        this.variantPriceAsUpsell = false;
        this.displayAboutOnlineOrdering = false;
        this.displayQuickCategories = false;
        this.replaceCompaniesLinkByOrderTypeLink = false;
        this.quickAdd = false;
        this.forceQuickAdd = false;
        this.itemImageBackgroundSize = "cover";
        this.styleMode = "classic";
        this.modifiersMode = "list";
        this.cartItemsMode = "classic";
        this.mobileProductsPerRow = 1;
        this.homePageAlignment = "center";
        this.horizontalLogoInMobileHeader = false;
        this.companyLogoOverride = false;
        this.companyHorizontalLogoOverride = false;
        this.forceModifierInteraction = false;
        this.tutorial = {
          displayCoverBackgroundImage: false,
          fullWidthImages: false
        };
        this.fidelity = {
          format: 'card',
          displayFooterProgressBar: false
        };
        this.listMode = {
          item: {
            mobile: false,
            desktop: false
          },
          category: {
            mobile: false,
            desktop: false
          }
        };
        this.customCss = "";
        this.colors = [];
        this.buildSelectors();
      },

      buildSelectors() {
        let builtSelectors = [];
        for (let style of this.stylesToConfigure) {
          if (!ConfigurableStyle[style]) {
            continue;
          }

          let currentStyleSelectors = ConfigurableStyle[style].map(x => {
            if (x.selectors.length > 0) {
              return x.selectors;
            }
          }).filter(x => typeof x !== "undefined");
          currentStyleSelectors = this.flatten(currentStyleSelectors);

          for (let item of currentStyleSelectors) {
            for (let modifiable of item.modifiable) {
              let found = this.selectors.filter((x) => {
                return x.selector.sort().join(',') === item.selector.sort().join(',') && x.attribute === modifiable;
              });
              builtSelectors.push({
                selector: item.selector,
                attribute: modifiable,
                value: found.length > 0 ? found[0].value : ""
              });
            }
          }
        }

        this.selectors = builtSelectors;
      },

      getSelector(selector, attribute) {
        let found = this.selectors.filter((x) => x.selector === selector && x.attribute === attribute);
        return found.length > 0 ? found[0] : null;
      },

      flatten(array) {
        return array.reduce((flat, next) => flat.concat(next), []);
      },

      getCssData() {
        return {
          version: this.version,
          colors: this.colors,
          listMode: this.listMode,
          categoryListMode: this.categoryListMode,
          mobileProductsPerRow: this.mobileProductsPerRow,
          itemImageBackgroundSize: this.itemImageBackgroundSize,
          homePageAlignment: this.homePageAlignment,
          showMobileFooter: this.showMobileFooter,
          variantPriceAsUpsell: this.variantPriceAsUpsell,
          replaceCompaniesLinkByOrderTypeLink: this.replaceCompaniesLinkByOrderTypeLink,
          cartItemsMode: this.cartItemsMode,
          modifiersMode: this.modifiersMode,
          discreteProductPrice: this.discreteProductPrice,
          forceModifierInteraction: this.forceModifierInteraction,
          hideCategoryTitles: this.hideCategoryTitles,
          forceQuickAdd: this.forceQuickAdd,
          displayAboutOnlineOrdering: this.displayAboutOnlineOrdering,
          displayQuickCategories: this.displayQuickCategories,
          companyLogoOverride: this.companyLogoOverride,
          companyHorizontalLogoOverride: this.companyHorizontalLogoOverride,
          horizontalLogoInMobileHeader: this.horizontalLogoInMobileHeader,
          quickAdd: this.quickAdd,
          fidelity: this.fidelity,
          tutorial: this.tutorial,
          interactiveMode: this.interactiveMode,
          customCss: this.customCss,
          styleMode: this.styleMode,
          selectors: this.selectors,
          showCategoriesDescription: this.showCategoriesDescription
        }
      },

      async save() {
        this.$store.commit('showSpinner', true);
        let response = await this.saveBranch({
          branchId: this.branchId,
          data: {
            backgroundImage: getImageData(this.branch.backgroundImage),
            navigationLogo: getImageData(this.branch.navigationLogo),
            horizontalLogo: getImageData(this.branch.horizontalLogo),
            modalOrderTypeImage: getImageData(this.branch.modalOrderTypeImage),
            mobileOrderTypeImage: getImageData(this.branch.mobileOrderTypeImage),
            navigationLogoBackground: getImageData(this.branch.navigationLogoBackground),
            mobileMenuLogo: getImageData(this.branch.mobileMenuLogo),
            defaultItemImage: getImageData(this.branch.defaultItemImage),
            defaultPromotionImage: getImageData(this.branch.defaultPromotionImage),
            hubImage: getImageData(this.branch.hubImage),
            mapMarkerImage: getImageData(this.branch.mapMarkerImage),
            takeoutImage: getImageData(this.branch.takeoutImage),
            takeoutBackgroundImage: getImageData(this.branch.takeoutBackgroundImage),
            deliveryImage: getImageData(this.branch.deliveryImage),
            deliveryBackgroundImage: getImageData(this.branch.deliveryBackgroundImage),
            inPlaceImage: getImageData(this.branch.inPlaceImage),
            inPlaceBackgroundImage: getImageData(this.branch.inPlaceBackgroundImage),
            cateringImage: getImageData(this.branch.cateringImage),
            cateringBackgroundImage: getImageData(this.branch.cateringBackgroundImage),
            hotelImage: getImageData(this.branch.hotelImage),
            hotelBackgroundImage: getImageData(this.branch.hotelBackgroundImage),
            spinnerStaticImage: getImageData(this.branch.spinnerStaticImage),
            spinnerAnimatedImage: getImageData(this.branch.spinnerAnimatedImage),
            tutorial: this.branch.tutorial ? {
              backgroundImage: getImageData(this.branch.tutorial.backgroundImage),
              logoImage: getImageData(this.branch.tutorial.logoImage),
            } : undefined,
            homePage: this.branch.homePage ? {
              backgroundImage: getImageData(this.branch.homePage.backgroundImage),
            } : undefined,
            payAtTheTable: this.branch.payAtTheTable ? {
              logo: getImageData(this.branch.payAtTheTable.logo),
              backgroundImage: getImageData(this.branch.payAtTheTable.backgroundImage)
            } : undefined,
            cssData: this.getCssData()
          }
        });
        if (response) {
          toast(this.$t("branch.success"), "success");
          let inventories = this.$store.state.contextBranch.inventories;
          this.$store.state.contextBranch = response;
          this.$store.state.contextBranch.inventories = inventories;
          this.getBranchStyle();
          this.buildSelectors();
        }
        this.$store.commit('showSpinner', false);
      },

      addColor() {
        this.colors.push({
          name: "",
          value: "#ffffff"
        })
      },

      hasAttribute(selector, attribute) {
        return (selector.modifiable.indexOf(attribute) > -1);
      },

      exportConfig() {
        let exportDate = new Date().toISOString().slice(0, 16).replace("T", "_");
        window._exportAsJson("css-data-export_" + this.branch.nameCanonical + "_" + exportDate, this.getCssData());
      },

      async importConfig(e) {
        console.log("event", e);
        let file = e.target.files[0];

        console.log("file type", file.type);

        if (!["application/json"].includes(file.type)) {
          toast("Format de fichier invalide. Veuillez choisir un .json.", "error");
        } else if (file.size > window.MAX_FILE_SIZE) {
          this.$modal.show("file-size-error");
        } else {
          let fileReader = new FileReader();
          fileReader.onload = async () => {
            let data = JSON.parse(fileReader.result.toString());
            console.log("data", data);
            this.branch.cssData = data;
            this.getBranchStyle();
            this.buildSelectors();
            this.forceUpdateAll();
          };
          fileReader.readAsText(file);
        }
      },

      forceUpdateAll() {
        this.$refs.generalPanel.$forceUpdate();
        this.$refs.mediaPanel.$forceUpdate();
        let stylesIndex = 0;
        for (let style of this.stylesToConfigure) {
          for (let i = 0; i < ConfigurableStyle[style].length; i++) {
            this.$refs["stylePanel" + stylesIndex + i][0].$forceUpdate();
          }
          stylesIndex++
        }
        this.$forceUpdate();
      },

      hasRegexAttribute(selector, regex) {
        for (let modifiable of selector.modifiable) {
          if (regex.test(modifiable)) {
            return modifiable;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .selector {
    display: flex;
    align-items: center;

    .tooltip {
      margin-right: 10px;
    }

    .color-select-holder,
    .number-select,
    .font-select,
    .background-select {
      flex-grow: 1;
    }
  }

  input[type=text].file-upload {
    margin-bottom: 0;
  }

  .btnDelete {
    margin-left: 10px;
    display: flex;
    fill: white;
  }

  .background {
    position: relative;

    .preview {
      position: absolute;
      right: 15px;
      top: 10px;
      width: 24px;
      height: 24px;
      margin-right: 10px;
      outline: 1px solid #d9d9d9;
      border: 1px solid white;
    }
  }

  .actions {
    display: flex;
    justify-content: center;
  }

  .config {
    width: 100%;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;

    .content {
      flex-grow: 1;
    }

    .content-inner {
      overflow-y: auto;
    }
  }

  .color {
    background-color: #f8f8f8;
    border: 1px solid rgb(230, 230, 230);
    padding: 10px;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;

    .group {
      flex-grow: 1;
      margin-right: 10px;
    }

    input[type=text],
    input[type=color] {
      margin-bottom: 0;
      flex-grow: 1;
      font-size: 16px;
    }

    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }

  input[type=text],
  input[type=number],
  select {
    margin-bottom: 6px;
  }

  .description {
    color: #808080;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }

  .add {
    fill: white;
    margin-left: 10px;
    padding: 10.5px
  }

  .delete {
    color: var(--primary-color);
    cursor: pointer;
    display: flex;
    align-items: center;

    .svgicon {
      margin-right: 5px;
      fill: #b4b4b4;
    }
  }
  </style>

  <style lang="scss">
  .section-title {
    font-weight: bold;
    margin-bottom: 15px;
  }

  #onlineOrderingStyle {
    .panel.config {
      padding: 20px;

      .content {
        flex-grow: 1;
        overflow-y: auto;
        padding-right: 10px;
      }

      textarea {
        height: 10em;
        font-size: 14px;
      }
    }

    .btn.btn-secondary {
      background-color: white;
    }
  }

  .openWebApp {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .grow {
      flex-grow: 1;
    }

    input.search {
      margin-right: 10px;
      margin-bottom: 0;
    }

    a {
      text-decoration: none;
      display: flex;
      align-items: center;
    }

    .svgicon {
      margin-left: 15px;
      fill: white;
      transform: rotate(-90deg);
    }
  }

  label {
    line-height: 1.1;
  }

  .br {
    border-bottom: 1px solid #d9d9d9;
    width: 100%;
    margin: 15px 0 30px 0;
  }

  .btn-save {
    position: fixed;
    right: 30px;
    bottom: 15px;
  }

  .customCss {
    resize: vertical;
    font-size: 12px;
    font-family: monospace;
    height: 10em;
  }

  .style-title {
    font-weight: bold;
    font-size: 22px;
    border-bottom: 1px solid var(--primary-color);
    padding: 20px 0 10px 0;
    margin-bottom: 30px;
  }
</style>
